import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { HiChevronRight } from 'react-icons/hi';
import { FaWhatsapp } from 'react-icons/fa';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { COMPANY_INFO } from '../utils/constants';

const CTASection = () => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.3 });

  return (
    <section
      ref={ref}
      style={{
        backgroundColor: '#111111',
        padding: 'clamp(4rem, 8vw, 7rem) 1.5rem',
      }}
    >
      <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <h2 style={{
            fontSize: 'clamp(2rem, 4.5vw, 3.5rem)',
            fontWeight: 700,
            letterSpacing: '-0.02em',
            lineHeight: 1.1,
            color: '#FFFFFF',
            marginBottom: '1.5rem',
            fontFamily: '"DM Sans", sans-serif',
          }}>
            Ready to stop doing manually what a bot can do better?
          </h2>

          <p style={{
            fontSize: '1.1rem',
            lineHeight: 1.65,
            color: 'rgba(255,255,255,0.5)',
            marginBottom: '2.5rem',
            maxWidth: '600px',
            margin: '0 auto 2.5rem',
            fontFamily: '"DM Sans", sans-serif',
          }}>
            Book a free 20-minute Automation Audit. No sales pitch. No obligation. Just clarity on what can be automated in your business.
          </p>

          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '1rem',
          }}>
            <Link
              to="/contact"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                padding: '16px 32px',
                backgroundColor: '#FFFFFF',
                color: '#111111',
                borderRadius: '999px',
                fontSize: '1rem',
                fontWeight: 600,
                textDecoration: 'none',
                fontFamily: '"DM Sans", sans-serif',
                transition: 'opacity 0.15s',
              }}
            >
              Book Free Audit <HiChevronRight size={18} />
            </Link>

            <a
              href={COMPANY_INFO.whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                padding: '16px 32px',
                backgroundColor: 'transparent',
                color: '#FFFFFF',
                border: '1.5px solid rgba(255,255,255,0.2)',
                borderRadius: '999px',
                fontSize: '1rem',
                fontWeight: 600,
                textDecoration: 'none',
                fontFamily: '"DM Sans", sans-serif',
                transition: 'border-color 0.15s',
              }}
            >
              <FaWhatsapp size={20} /> WhatsApp Us
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
